const appConfig = angular.module("sdApp.config", []);

export default appConfig;
